import { useQuery } from "@tanstack/react-query";
import api from "../../../lib/api";
import { actionBadgeQueryOptions } from "../../../hooks/actionBadgeQuery";

export const DESIGN_REVIEW_COUNT_KEY = ["design-jobs", "review-count"] as const;

export function useReviewableDesignRunCount({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<number>({
    ...actionBadgeQueryOptions,
    queryKey: DESIGN_REVIEW_COUNT_KEY,
    queryFn: ({ signal }) =>
      api
        .get("/api/design-generator/jobs/review-count", { signal })
        .then((r) => r.data.reviewCount),
    enabled,
  });
}
